var _style, _defs, _rect, _defs2, _rect2, _defs3, _rect3, _defs4, _rect4, _defs5, _rect5, _defs6, _rect6, _defs7, _rect7, _g, _defs8, _rect8, _defs9, _rect9, _defs10, _rect10, _defs11, _rect11, _defs12, _rect12, _defs13, _rect13, _defs14, _rect14, _defs15, _rect15, _defs16, _rect16, _defs17, _rect17, _rect18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkylineWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 195.94 53.12",
    style: {
      enableBackground: "new 0 0 195.94 53.12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);fill:#FFFFFF;}\r\n\t.st1{clip-path:url(#SVGID_4_);fill:#FFFFFF;}\r\n\t.st2{clip-path:url(#SVGID_6_);fill:#FFFFFF;}\r\n\t.st3{clip-path:url(#SVGID_8_);fill:#FFFFFF;}\r\n\t.st4{clip-path:url(#SVGID_10_);fill:#FFFFFF;}\r\n\t.st5{clip-path:url(#SVGID_12_);fill:#FFFFFF;}\r\n\t.st6{clip-path:url(#SVGID_14_);fill:#FFFFFF;}\r\n\t.st7{fill:#FFFFFF;}\r\n\t.st8{clip-path:url(#SVGID_16_);fill:#FFFFFF;}\r\n\t.st9{clip-path:url(#SVGID_18_);fill:#FFFFFF;}\r\n\t.st10{clip-path:url(#SVGID_20_);fill:#FFFFFF;}\r\n\t.st11{clip-path:url(#SVGID_22_);fill:#FFFFFF;}\r\n\t.st12{clip-path:url(#SVGID_24_);fill:#FFFFFF;}\r\n\t.st13{clip-path:url(#SVGID_26_);fill:#FFFFFF;}\r\n\t.st14{clip-path:url(#SVGID_28_);fill:#FFFFFF;}\r\n\t.st15{clip-path:url(#SVGID_30_);fill:#FFFFFF;}\r\n\t.st16{clip-path:url(#SVGID_32_);fill:#FFFFFF;}\r\n\t.st17{clip-path:url(#SVGID_34_);fill:#FFFFFF;}\r\n\t.st18{fill:#000923;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 40.07,
    y: 39.21,
    width: 2.33,
    height: 8.93
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.97,
    y: 39.19,
    transform: "matrix(0.9997 -0.0225 0.0225 0.9997 -0.9709 0.9374)",
    className: "st0",
    width: 2.53,
    height: 8.98
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_3_",
    points: "61.32,39.21 63.49,39.21 63.49,48.14 61.45,48.14 57.4,42.81 57.4,48.14 55.22,48.14 55.22,39.21  57.27,39.21 61.34,44.59  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 55.12,
    y: 39.12,
    transform: "matrix(0.9997 -0.0225 0.0225 0.9997 -0.9663 1.3445)",
    className: "st1",
    width: 8.47,
    height: 9.12
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_5_",
    points: "76.32,39.21 83,39.21 82.99,41.07 78.65,41.07 78.65,43.06 82.66,43.06 82.66,44.92 78.65,44.92  78.65,48.14 76.32,48.14  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 76.22,
    y: 39.14,
    transform: "matrix(0.9997 -0.0225 0.0225 0.9997 -0.9612 1.8007)",
    className: "st2",
    width: 6.88,
    height: 9.08
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M98.2,45.97c-0.37-0.23-0.67-0.55-0.9-0.96c-0.23-0.4-0.34-0.85-0.34-1.34c0-0.48,0.11-0.93,0.33-1.33 c0.22-0.4,0.52-0.72,0.9-0.95c0.38-0.23,0.79-0.34,1.23-0.34c0.44,0,0.85,0.11,1.22,0.34c0.37,0.23,0.66,0.55,0.87,0.95 c0.21,0.4,0.32,0.85,0.32,1.33c0,0.49-0.11,0.94-0.32,1.34c-0.21,0.4-0.5,0.72-0.87,0.96c-0.37,0.23-0.78,0.35-1.22,0.35 C98.98,46.32,98.58,46.21,98.2,45.97 M96.93,39.67c-0.74,0.4-1.31,0.95-1.73,1.64c-0.42,0.7-0.63,1.48-0.63,2.34 c0,0.88,0.21,1.67,0.63,2.38c0.42,0.71,1,1.27,1.73,1.67c0.73,0.4,1.56,0.61,2.47,0.61c0.91,0,1.73-0.2,2.47-0.61 c0.73-0.41,1.31-0.96,1.73-1.67c0.42-0.71,0.63-1.5,0.63-2.37c0-0.87-0.21-1.65-0.63-2.34c-0.42-0.7-1-1.24-1.73-1.64 c-0.74-0.4-1.56-0.6-2.47-0.6C98.49,39.07,97.67,39.27,96.93,39.67"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 94.47,
    y: 38.96,
    transform: "matrix(0.9997 -0.0225 0.0225 0.9997 -0.9564 2.2441)",
    className: "st3",
    width: 9.86,
    height: 9.45
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_9_",
    d: "M118.06,39.37c-0.54,0.23-0.96,0.55-1.25,0.96c-0.29,0.42-0.44,0.9-0.44,1.45c0,0.59,0.14,1.06,0.43,1.41 c0.28,0.35,0.63,0.62,1.03,0.79c0.4,0.17,0.9,0.35,1.52,0.52c0.41,0.11,0.72,0.21,0.95,0.29c0.22,0.08,0.41,0.19,0.56,0.33 c0.15,0.14,0.22,0.31,0.22,0.51c0,0.25-0.1,0.43-0.3,0.56c-0.2,0.13-0.47,0.19-0.82,0.19c-0.48,0-1.02-0.13-1.64-0.38 c-0.62-0.26-1.15-0.58-1.6-0.98l-0.9,1.82c0.53,0.45,1.17,0.81,1.91,1.06c0.73,0.26,1.47,0.39,2.21,0.39 c0.67,0,1.28-0.11,1.83-0.32c0.55-0.21,0.98-0.53,1.29-0.95c0.31-0.42,0.47-0.93,0.47-1.52c0-0.59-0.14-1.08-0.43-1.45 c-0.29-0.37-0.64-0.64-1.04-0.82c-0.4-0.18-0.92-0.36-1.54-0.53c-0.42-0.13-0.73-0.23-0.94-0.31c-0.21-0.08-0.39-0.19-0.53-0.32 c-0.14-0.13-0.22-0.29-0.22-0.49c0-0.2,0.08-0.36,0.25-0.46c0.17-0.11,0.39-0.16,0.68-0.16c0.36,0,0.82,0.09,1.36,0.27 c0.54,0.18,1.05,0.41,1.52,0.69l0.88-1.86c-0.48-0.31-1.03-0.55-1.66-0.73c-0.63-0.18-1.27-0.27-1.91-0.27 C119.23,39.03,118.6,39.15,118.06,39.37"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 115.71,
    y: 38.95,
    transform: "matrix(0.9997 -0.0225 0.0225 0.9997 -0.9506 2.6995)",
    className: "st4",
    width: 7.91,
    height: 9.42
  }))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_11_",
    points: "141.38,39.21 139.31,43.05 137.2,39.21 134.86,39.21 138.15,45.35 138.15,48.14 140.48,48.14  140.48,45.29 143.71,39.21  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 134.76,
    y: 39.11,
    transform: "matrix(0.9997 -0.0225 0.0225 0.9997 -0.9461 3.1402)",
    className: "st5",
    width: 9.04,
    height: 9.13
  }))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_13_",
    d: "M157.18,39.37c-0.54,0.23-0.96,0.55-1.25,0.96c-0.29,0.42-0.44,0.9-0.44,1.45c0,0.59,0.14,1.06,0.43,1.41 c0.28,0.35,0.63,0.62,1.03,0.79c0.4,0.17,0.9,0.35,1.52,0.52c0.41,0.11,0.72,0.21,0.95,0.29c0.23,0.08,0.41,0.19,0.56,0.33 c0.15,0.14,0.22,0.31,0.22,0.51c0,0.25-0.1,0.43-0.3,0.56c-0.2,0.13-0.47,0.19-0.82,0.19c-0.48,0-1.02-0.13-1.64-0.38 c-0.62-0.26-1.15-0.58-1.6-0.98l-0.9,1.82c0.54,0.45,1.17,0.81,1.91,1.06c0.73,0.26,1.47,0.39,2.21,0.39 c0.67,0,1.28-0.11,1.83-0.32c0.55-0.21,0.98-0.53,1.29-0.95c0.31-0.42,0.47-0.93,0.47-1.52c0-0.59-0.14-1.08-0.43-1.45 c-0.29-0.37-0.64-0.64-1.04-0.82c-0.4-0.18-0.92-0.36-1.54-0.53c-0.42-0.13-0.73-0.23-0.94-0.31c-0.21-0.08-0.39-0.19-0.53-0.32 c-0.14-0.13-0.22-0.29-0.22-0.49c0-0.2,0.08-0.36,0.25-0.46c0.17-0.11,0.39-0.16,0.68-0.16c0.36,0,0.82,0.09,1.36,0.27 c0.54,0.18,1.05,0.41,1.52,0.69l0.88-1.86c-0.48-0.31-1.03-0.55-1.66-0.73c-0.63-0.18-1.27-0.27-1.91-0.27 C158.35,39.03,157.72,39.15,157.18,39.37"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 154.83,
    y: 38.95,
    transform: "matrix(0.9997 -0.0225 0.0225 0.9997 -0.9408 3.5784)",
    className: "st6",
    width: 7.91,
    height: 9.42
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M13.37,44.63c-3.18,0-5.9-2.87-5.94-6.27c0-0.17,0-0.34,0.02-0.52l0.02-0.2l4.24-2.89l0.01,0.81 c0,0.12,0.02,0.93,0.05,1.69c0.02,0.66,0.04,1.27,0.04,1.35c0.01,0.87,0.71,1.58,1.56,1.59c0.88-0.01,1.57-0.74,1.56-1.62 l-0.21-17.71c0-0.15,0-0.29,0.01-0.44c0.17-3.14,2.74-5.65,5.84-5.68l0.07,0c3.23,0,5.89,2.68,5.93,5.98 c0,0.28-0.01,0.54-0.05,0.83l-0.03,0.2l-4.25,2.79l-0.04-3.76c-0.01-0.87-0.71-1.58-1.56-1.58c-0.88,0.01-1.57,0.74-1.56,1.62 l0.21,17.71c0.01,0.56-0.06,1.12-0.2,1.64c-0.68,2.6-3,4.45-5.65,4.48L13.37,44.63z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_15_",
    d: "M0.58,13.67v25.47c0,0.28,0.01,0.62,0.05,0.95c0.08,0.72,0.23,1.46,0.44,2.2 c1.63,5.54,6.8,9.41,12.57,9.41l0.17,0c3.5-0.04,6.78-1.44,9.23-3.96c2.45-2.51,3.78-5.82,3.74-9.32l-0.08-14.54l-3.98,2.46 l-0.06,12.14c0.03,2.4-0.88,4.67-2.56,6.39c-1.68,1.72-3.93,2.69-6.33,2.71l-0.11,0c-4.37,0-8.09-3.12-8.85-7.43 c-0.09-0.48-0.13-0.95-0.14-1.45l-0.02-1.22V13.67c0-1.12-0.91-2.04-2.03-2.04C1.49,11.64,0.58,12.55,0.58,13.67"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 0.13,
    y: 11.35,
    transform: "matrix(0.9997 -0.0225 0.0225 0.9997 -0.708 0.3158)",
    className: "st8",
    width: 27.13,
    height: 40.64
  }))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_17_",
    d: "M20.18,7.67C12.95,7.76,7.14,13.72,7.23,20.95l0,14.64l4.06-2.52l0.07-12.17 c-0.03-2.4,0.88-4.67,2.56-6.39c1.68-1.72,3.93-2.69,6.33-2.72l0.11,0c4.37,0,8.09,3.12,8.86,7.42c0.09,0.51,0.13,0.98,0.14,1.46 l0.01,0.89v26.25c0,1.12,0.91,2.03,2.03,2.03c1.12,0,2.03-0.91,2.03-2.03l0-28.14c0-0.07-0.01-0.13-0.02-0.21 c-0.08-0.78-0.23-1.56-0.46-2.38c-1.63-5.55-6.8-9.43-12.58-9.43L20.18,7.67z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 6.67,
    y: 7.38,
    transform: "matrix(0.9997 -0.0225 0.0225 0.9997 -0.6411 0.4628)",
    className: "st9",
    width: 27.22,
    height: 42.77
  }))), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_19_",
    d: "M45.42,11.39c-1.47,0.61-2.62,1.5-3.43,2.65c-0.81,1.15-1.22,2.5-1.22,4.02c0,1.62,0.41,2.94,1.21,3.93 c0.78,0.97,1.73,1.7,2.83,2.18c1.05,0.46,2.39,0.91,3.99,1.36c1.04,0.28,1.85,0.53,2.42,0.73c0.52,0.19,0.96,0.44,1.3,0.75 c0.29,0.26,0.43,0.59,0.43,0.98c0,0.48-0.18,0.82-0.57,1.07c-0.44,0.28-1.07,0.42-1.88,0.42c-1.17,0-2.53-0.32-4.07-0.96 c-1.54-0.64-2.89-1.47-4.01-2.46l-0.44-0.39l-2.77,5.57l0.27,0.23c1.42,1.2,3.13,2.15,5.07,2.84c1.94,0.68,3.92,1.03,5.88,1.03 c1.78,0,3.43-0.29,4.9-0.86c1.49-0.58,2.69-1.46,3.55-2.61c0.87-1.17,1.31-2.58,1.31-4.22c0-1.64-0.41-2.99-1.22-4.02 c-0.79-1.01-1.75-1.77-2.86-2.26c-1.06-0.47-2.42-0.94-4.03-1.4c-1.07-0.33-1.88-0.6-2.41-0.8c-0.49-0.19-0.91-0.44-1.24-0.74 c-0.28-0.26-0.41-0.55-0.41-0.93c0-0.37,0.14-0.63,0.43-0.82c0.83-0.53,2.56-0.44,4.89,0.33c1.36,0.45,2.66,1.04,3.85,1.74 l0.43,0.25l2.66-5.63l-0.34-0.22c-1.26-0.81-2.75-1.47-4.41-1.95c-1.66-0.48-3.37-0.73-5.08-0.73 C48.56,10.48,46.86,10.79,45.42,11.39"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 38.61,
    y: 9.99,
    transform: "matrix(0.9988 -0.0486 0.0486 0.9988 -1.0539 2.4421)",
    className: "st10",
    width: 22.26,
    height: 25.86
  }))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_21_",
    points: "79.58,10.95 71.56,20.21 71.56,10.95 64.61,10.95 64.61,34.99 71.56,34.99 71.56,28.96  73.96,26.29 79.84,34.99 88.16,34.99 78.78,20.98 87.06,11.78 87.8,10.95  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 64.04,
    y: 10.39,
    transform: "matrix(0.9988 -0.0486 0.0486 0.9988 -1.025 3.736)",
    className: "st11",
    width: 24.69,
    height: 25.15
  }))), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_23_",
    points: "116.9,10.95 116.9,34.98 133.64,34.98 133.64,28.93 123.84,28.93 123.84,10.95  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 116.32,
    y: 10.55,
    transform: "matrix(0.9988 -0.0486 0.0486 0.9988 -0.9673 6.1094)",
    className: "st12",
    width: 17.89,
    height: 24.82
  }))), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_25_",
    x: 138.2,
    y: 10.95,
    width: 6.95,
    height: 24.04
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 137.62,
    y: 10.79,
    transform: "matrix(0.9988 -0.0486 0.0486 0.9988 -0.9479 6.9058)",
    className: "st13",
    width: 8.11,
    height: 24.35
  }))), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_27_",
    points: "164.98,10.95 165.01,26.52 155.17,10.95 149.18,10.95 149.18,34.99 155.73,34.99 155.73,22.05  171.5,47.17 171.5,10.95  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 148.31,
    y: 10.43,
    transform: "matrix(0.9988 -0.0486 0.0486 0.9988 -1.2217 7.8194)",
    className: "st14",
    width: 24.05,
    height: 37.26
  }))), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_29_",
    points: "176.02,10.95 176.02,34.98 195.5,34.98 195.5,29.26 182.97,29.26 182.97,25.81 193.99,25.78  193.99,20.08 182.97,20.08 182.97,16.67 195.17,16.67 195.17,10.95  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 175.45,
    y: 10.49,
    transform: "matrix(0.9988 -0.0486 0.0486 0.9988 -0.8959 9.0465)",
    className: "st15",
    width: 20.63,
    height: 24.96
  }))), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_31_",
    points: "106.93,10.95 101.85,20.38 96.65,10.96 96.65,10.95 89.48,10.95 90.31,12.31 98.4,27.42  98.4,34.99 105.35,34.99 105.35,27.25 113.99,10.95  "
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 88.91,
    y: 10.37,
    transform: "matrix(0.9988 -0.0486 0.0486 0.9988 -0.9951 4.9669)",
    className: "st16",
    width: 25.65,
    height: 25.2
  }))), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_33_",
    d: "M137.95,6.81c-0.36-0.81-0.44-1.65-0.27-2.52c0.01-0.03,0-0.07,0.05-0.09c0.14-0.05,0.23-0.14,0.29-0.27 c0.07-0.13,0.2-0.18,0.33-0.11c0.07,0.03,0.13,0.04,0.2,0.01c0.02-0.01,0.05-0.04,0.07,0c0.04,0.09,0.16,0.14,0.14,0.27 c0,0.02,0.01,0.06,0.02,0.07c0.11,0.11,0.17,0.25,0.27,0.36c0.1,0.1,0.12,0.22,0.04,0.34c-0.04,0.07-0.04,0.14,0,0.21 c0.05,0.08,0.03,0.17-0.01,0.24c-0.09,0.18-0.24,0.32-0.4,0.45c-0.03,0.03-0.06,0.02-0.09,0.01c-0.14-0.02-0.28-0.03-0.42-0.07 c-0.13-0.04-0.23,0.08-0.19,0.2c0.03,0.08,0.01,0.15-0.01,0.22c-0.07,0.18-0.07,0.36,0.03,0.53c0.06,0.1,0.09,0.22,0.09,0.37 C138.01,6.96,137.99,6.88,137.95,6.81 M137.9,3.63c0.02-0.03,0.07-0.17,0.07-0.2c0-0.01,0-0.01,0.01-0.02 c0.09-0.19,0.2-0.38,0.32-0.55c0.03-0.04,0.05-0.04,0.09,0c0.08,0.06,0.14,0.18,0.27,0.13c-0.03,0.05-0.09,0.07-0.11,0.12 c-0.03,0.05-0.09,0.11-0.05,0.17c0.04,0.07,0.11,0.03,0.17,0c0.12-0.05,0.15-0.02,0.13,0.11c0,0.03-0.01,0.06-0.01,0.09 c0.02,0.15-0.02,0.21-0.16,0.26c-0.1,0.03-0.22-0.03-0.24-0.14c-0.01-0.08-0.08-0.11-0.11-0.18c-0.02-0.04-0.2-0.01-0.21,0.03 c-0.04,0.12-0.16,0.18-0.21,0.32C137.84,3.69,137.88,3.67,137.9,3.63 M138.55,2.79c0.08-0.15,0.19-0.28,0.31-0.42 c0.02,0.09,0,0.13-0.09,0.21c-0.03,0.03-0.06,0.06-0.04,0.11c0.03,0.11-0.02,0.16-0.14,0.16c0,0,0,0,0,0 C138.53,2.86,138.53,2.83,138.55,2.79 M143.33,2.52c0.07-0.04,0.12-0.12,0.1-0.21c-0.03-0.11-0.08-0.23-0.21-0.26 c-0.07-0.02-0.16-0.02-0.19-0.08c-0.05-0.13-0.14-0.15-0.26-0.17c-0.02,0-0.04-0.01-0.06-0.02c-0.07-0.04-0.06-0.08,0-0.11 c0.07-0.04,0.12-0.01,0.16,0.05c0.03,0.04,0.08,0.08,0.13,0.02c0.04-0.04,0.2-0.07,0.23-0.03c0.09,0.14,0.21,0.18,0.37,0.16 c0.02,0,0.04,0.01,0.06,0.02c0.2,0.02,0.39,0.12,0.58,0.15c0.05,0.01,0.09,0.03,0.12,0.07c0.27,0.25,0.5,0.52,0.7,0.82 c0.07,0.11,0.08,0.2,0.02,0.31c-0.08,0.14-0.08,0.28-0.04,0.45c0.07,0.25,0.07,0.52-0.16,0.71c-0.03,0.02-0.03,0.06-0.04,0.09 c-0.04,0.22-0.19,0.38-0.29,0.57c0.03-0.13,0.06-0.27,0.17-0.38c0.01-0.01,0.02-0.04,0.02-0.06c0.01-0.04,0.02-0.08-0.02-0.1 c-0.05-0.02-0.05,0.04-0.07,0.07c-0.05,0.13-0.13,0.24-0.22,0.34c-0.07,0.09-0.13,0.17-0.15,0.29c-0.01,0.05-0.02,0.1-0.07,0.12 c-0.18,0.07-0.32,0.22-0.53,0.21c-0.04,0-0.08,0.01-0.1,0.05c-0.04,0.07-0.11,0.1-0.19,0.12c-0.12,0.02-0.23,0.07-0.26,0.21 c-0.01,0.05-0.05,0.07-0.09,0.09c-0.09,0.04-0.17,0.08-0.26,0.13c-0.02,0.01-0.05,0.03-0.06-0.01c-0.02-0.05-0.05-0.08-0.1-0.06 c-0.03,0.01-0.05,0.03-0.05,0.05c0,0.06,0.06,0.06,0.09,0.09c0.11,0.08,0.2,0.18,0.18,0.33c-0.01,0.13,0.03,0.22,0.12,0.3 c0.06,0.06,0.09,0.13,0.05,0.22c-0.01,0.03-0.02,0.05,0,0.07c0.07,0.08,0.03,0.14-0.04,0.19c-0.05,0.04-0.09,0.08-0.12,0.14 c-0.09,0.21-0.23,0.36-0.43,0.45c-0.1,0.04-0.14,0.12-0.14,0.23c0,0.22,0.06,0.43,0.1,0.65c0.02,0.11,0.01,0.22-0.03,0.31 c-0.03,0.07-0.13,0.04-0.2,0.06c-0.07,0.02-0.13,0.01-0.17-0.06c-0.02-0.03-0.06-0.04-0.09-0.06c-0.11-0.04-0.2-0.15-0.34-0.13 c-0.02,0-0.04-0.03-0.06-0.05c-0.03-0.03-0.06-0.06-0.09-0.07c-0.19-0.1-0.35-0.22-0.44-0.43c-0.02-0.05-0.07-0.07-0.11-0.08 c-0.08-0.02-0.16-0.04-0.24-0.06c-0.04-0.01-0.08-0.01-0.09-0.05c-0.06-0.13-0.18-0.23-0.2-0.38c-0.02-0.14-0.08-0.23-0.19-0.32 c-0.11-0.09-0.07-0.22,0.05-0.29c0.14-0.08,0.3-0.08,0.43-0.16c0.1-0.06,0.21-0.1,0.32-0.1c0.05,0,0.07-0.01,0.09-0.07 c0.06-0.22,0.13-0.28,0.36-0.29c0.06,0,0.12-0.02,0.16-0.07c0.07-0.1,0.21-0.12,0.29-0.2c0.03-0.03,0.09-0.03,0.14-0.03 c0.1,0,0.2-0.02,0.29-0.06c0.08-0.04,0.13-0.03,0.16,0.06c0,0.02,0.01,0.04,0.03,0.04c0.03,0,0.04-0.02,0.05-0.04 c0.01-0.02,0.01-0.05,0.01-0.08c0.02-0.16,0.07-0.19,0.22-0.15c0.1,0.03,0.16-0.02,0.2-0.1c0.03-0.06,0.02-0.11,0.01-0.17 c-0.02-0.12,0.02-0.19,0.14-0.18c0.17,0.01,0.24-0.05,0.16-0.27c-0.01-0.03-0.03-0.05-0.04-0.08c-0.02-0.04-0.01-0.06,0.03-0.06 c0.07,0,0.13,0.01,0.16,0.08c0.06,0.15,0.24,0.18,0.36,0.06c0.09-0.1,0.16-0.22,0.11-0.35c-0.05-0.15-0.1-0.35-0.3-0.35 c-0.19-0.01-0.35-0.14-0.55-0.07c-0.07,0.03-0.12,0.04-0.14,0.11c-0.01,0.07-0.03,0.13-0.08,0.18c-0.02,0.02-0.04,0.04-0.07,0.03 c-0.02-0.01-0.02-0.04-0.02-0.06c0-0.07,0.03-0.14,0.05-0.21c0.04-0.14,0.02-0.19-0.1-0.27c-0.13-0.08-0.21-0.19-0.24-0.34 c-0.01-0.07-0.05-0.11-0.09-0.17c-0.08-0.11-0.2-0.17-0.26-0.28c-0.1-0.18-0.29-0.14-0.46-0.22c0.03,0.07,0.06,0.07,0.09,0.09 c0.01,0.01,0.03,0.03,0.02,0.05c-0.01,0.02-0.03,0.02-0.05,0.01c-0.06-0.06-0.15-0.07-0.23-0.12c0.05-0.02,0.09-0.02,0.12-0.04 c0.06-0.04,0.14-0.1,0.11-0.16c-0.05-0.09-0.01-0.08,0.03-0.08c0.01,0,0.02,0,0.03,0c0.08,0,0.15,0.02,0.21,0.08 c0.02,0.02,0.04,0.06,0.09,0.04c-0.08-0.08-0.16-0.14-0.26-0.19c-0.18-0.08-0.39,0.01-0.58-0.1c-0.11-0.06-0.16-0.09-0.14-0.24 c0.02-0.11,0.1-0.18,0.21-0.16c0.12,0.03,0.19-0.01,0.24-0.12c0.06-0.14,0.09-0.14,0.22-0.06c0.08,0.05,0.18,0.03,0.21-0.06 c0.03-0.09,0.11-0.12,0.18-0.15c0.09-0.04,0.2-0.03,0.29-0.01c0.07,0.01,0,0.1,0.02,0.16c0.01,0.02,0.01,0.03,0.02,0.05 c0.02,0.03,0.01,0.06-0.01,0.09c-0.08,0.12-0.08,0.13,0.04,0.22c0.06,0.04,0.08,0.09,0.07,0.16c-0.01,0.07-0.01,0.15,0.08,0.16 c0.08,0.01,0.09-0.07,0.11-0.13c0-0.01,0-0.02,0-0.03c0.03-0.14,0.1-0.19,0.24-0.18c0.02,0,0.05,0,0.07,0 C143.16,2.59,143.25,2.57,143.33,2.52 M142.59,1.39c0.01-0.02,0.03-0.02,0.06-0.02c0.09,0,0.15,0.05,0.15,0.15 c0.05-0.01,0.06-0.04,0.07-0.07c0.02-0.05,0.06-0.02,0.09-0.01c0.03,0.01,0.07,0.04,0.06,0.07c-0.01,0.03-0.05,0.07-0.05,0.07 c-0.11,0-0.23,0.03-0.32-0.01c-0.19-0.09-0.33,0.01-0.49,0.08c-0.03,0.01-0.06,0.04-0.03,0.07c0.06,0.06,0.09,0.17,0.21,0.16 c0.03,0,0.07,0,0.1,0.04c-0.04,0.03-0.07,0.03-0.1,0.01c-0.1-0.05-0.18-0.01-0.26,0.05c-0.09,0.06-0.19,0.09-0.31,0.1 c0.02-0.06,0.1-0.04,0.11-0.1c-0.06-0.02-0.1,0.01-0.15,0.02c-0.03,0-0.05,0.01-0.07-0.02c-0.01-0.03,0.02-0.05,0.04-0.06 c0.03-0.02,0.07-0.04,0.11-0.06c0.02-0.01,0.06-0.03,0.05-0.06c-0.02-0.03-0.06-0.05-0.1-0.03c-0.02,0.01-0.05,0.02-0.07,0.04 c-0.04,0.04-0.09,0.03-0.13,0.01c-0.02-0.01-0.05-0.01-0.05-0.04c0-0.03,0.03-0.04,0.05-0.05c0.07-0.02,0.14-0.04,0.21-0.07 c0.05-0.02,0.12-0.01,0.08-0.1c-0.02-0.03,0.02-0.03,0.04-0.03c0.1-0.02,0.22-0.03,0.29-0.08c0.11-0.06,0.17-0.02,0.26,0 c0.02,0,0.04,0.01,0.06,0.01C142.54,1.44,142.57,1.43,142.59,1.39 M140.33,2.01c-0.01-0.04,0.01-0.08,0-0.11 c-0.02-0.08,0.02-0.2-0.08-0.24c-0.11-0.03-0.2-0.07-0.27-0.15c-0.02-0.02-0.06-0.01-0.05-0.04c0.01-0.03,0.04-0.03,0.06-0.04 c0.16-0.07,0.32-0.13,0.49-0.18c0.31-0.1,0.63-0.15,0.97-0.17c-0.11,0.09-0.2,0.19-0.34,0.23c0.04,0.03,0.06,0.03,0.09,0.03 c0.01,0,0.02,0,0.03,0c0.03,0,0.07,0,0.06,0.04c0,0.03-0.04,0.02-0.06,0.02c-0.03,0-0.06-0.02-0.11,0 c0.15,0.11,0.15,0.16,0.02,0.28c-0.04,0.04-0.07,0.08-0.1,0.13C140.95,1.94,140.84,2,140.69,2c-0.09,0-0.16,0-0.23,0.07 c-0.02,0.02-0.04,0.03-0.06,0.03C140.37,2.09,140.34,2.06,140.33,2.01 M141.67,0.84c-2.37,0-4.29,1.93-4.29,4.31 c0,2.36,1.93,4.28,4.29,4.28c2.37,0,4.3-1.92,4.3-4.28C145.97,2.77,144.05,0.84,141.67,0.84C141.67,0.84,141.67,0.84,141.67,0.84"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    style: {
      overflow: "visible",
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_34_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    style: {
      overflow: "visible"
    }
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 137.24,
    y: 0.71,
    transform: "matrix(0.9995 -0.0321 0.0321 0.9995 -0.092 4.5458)",
    className: "st17",
    width: 8.86,
    height: 8.86
  }))), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: -1551.66,
    y: -468.52,
    className: "st18",
    width: 1080,
    height: 1080
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkylineWhite);
export default __webpack_public_path__ + "static/media/skyline-white.e577ac44ae0eb8bac5dd4610aefc8a3b.svg";
export { ForwardRef as ReactComponent };